import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from 'emotion-theming';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var componentPadding = "\n    overflow: auto;\n    padding-left: " + spacing(2) + "; \n    padding-top: " + spacing(2) + ";\n";
var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 42%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};
var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;
var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    hover: greyLightest
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    deprecated: 'hsl(45, 100%, 51%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  }
};

var _templateObject = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\t', ';\n'], ['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\t', ';\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\tflex: 1 1 auto;\n'], ['\n\tflex: 1 1 auto;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin: ', ' auto ', ' auto;\n\tpadding: 0 ', ';\n\tmax-width: 1328px;\n\t', '\n\t', '\n\t', '\n'], ['\n\tbox-sizing: border-box;\n\tmargin: ', ' auto ', ' auto;\n\tpadding: 0 ', ';\n\tmax-width: 1328px;\n\t', '\n\t', '\n\t', '\n']),
    _templateObject4 = taggedTemplateLiteral(['\n\t', ';\n\tmargin: 0 auto;\n\tmax-width: 640px;\n\t', ';\n'], ['\n\t', ';\n\tmargin: 0 auto;\n\tmax-width: 640px;\n\t', ';\n']),
    _templateObject5 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tmargin: 0 auto ', ' auto;\n\tmax-width: 640px;\n\t', ' ', ';\n'], ['\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tmargin: 0 auto ', ' auto;\n\tmax-width: 640px;\n\t', ' ', ';\n']),
    _templateObject6 = taggedTemplateLiteral(['\n\tmargin-top: ', ';\n'], ['\n\tmargin-top: ', ';\n']);

var StyledWrapper = styled('div')(_templateObject, colours.backgrounds.shell, function (props) {
  return props.theme.styles.pageBackground && breakpointAndUp.lg2(props.theme.styles.pageBackground);
});
var StyledContentWrapper = styled('div')(_templateObject2);
var StyledContainer = styled('div')(_templateObject3, spacing(3), spacing(3), spacing(3), breakpointAndUp.lg3('\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin: ' + spacing(4) + ' auto ' + spacing(4) + ' auto;\n\t'), function (props) {
  return props.hasLeftSidebar && breakpointAndUp.lg1('justify-content: flex-start;');
}, function (props) {
  return props.hasRightSidebar && breakpointAndUp.lg1('justify-content: flex-end;');
});
var StyledAside = styled('aside')(_templateObject4, function (props) {
  return props.isHiddenMobile && 'display: none; ' + breakpointAndUp.lg3('display: block;');
}, breakpointAndUp.lg3('flex-basis: calc(25% - ' + spacing(3) + '); flex-grow: 0; flex-shrink: 1; margin: 0;'));
var StyledMain = styled('main')(_templateObject5, colours.neutral.white, function (props) {
  return props.theme.borderRadiusLargest;
}, spacing(3), componentPadding, breakpointAndUp.lg3('flex-basis: 50%; flex-grow: 0; flex-shrink: 0; margin: 0 ' + spacing(3) + ';'));
var StyledFooter = styled('div')(_templateObject6, spacing(10));

var ApplicationFormShell = function ApplicationFormShell(_ref) {
  var children = _ref.children,
      footer = _ref.footer,
      header = _ref.header,
      leftSidebar = _ref.leftSidebar,
      rightSidebar = _ref.rightSidebar,
      utilityNavigation = _ref.utilityNavigation;
  return React.createElement(StyledWrapper, null, React.createElement(StyledContentWrapper, null, header, utilityNavigation, React.createElement(StyledContainer, {
    hasLeftSidebar: !!leftSidebar,
    hasRightSidebar: !!rightSidebar
  }, leftSidebar && React.createElement(StyledAside, {
    isHiddenMobile: true
  }, leftSidebar), React.createElement(StyledMain, null, children), rightSidebar && React.createElement(StyledAside, null, rightSidebar))), footer && React.createElement(StyledFooter, null, footer));
};

ApplicationFormShell.propTypes = {
  /** Main column content as node. */
  children: PropTypes.node.isRequired,

  /** Desired footer component as node. */
  footer: PropTypes.node,

  /** Desired header component as node. */
  header: PropTypes.node.isRequired,

  /** Left sidebar content as node. */
  leftSidebar: PropTypes.node,

  /** Right sidebar content as node. */
  rightSidebar: PropTypes.node,

  /** Desired utility navigation component as node. */
  utilityNavigation: PropTypes.node
};
ApplicationFormShell.defaultProps = {};
var WrappedApplicationFormShell = withTheme(ApplicationFormShell);

WrappedApplicationFormShell.defaultExample = function (header, nav) {
  return React.createElement(WrappedApplicationFormShell, {
    header: header,
    utilityNavigation: nav
  }, React.createElement('span', null, 'Some test content.'));
};

var _templateObject$1 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\t', ';\n'], ['\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\t', ';\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tflex: 1 1 auto;\n'], ['\n\tflex: 1 1 auto;\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin: ', ' auto 0 auto;\n\tpadding: 0 ', ';\n\tmax-width: 1328px;\n\t', ';\n'], ['\n\tbox-sizing: border-box;\n\tmargin: ', ' auto 0 auto;\n\tpadding: 0 ', ';\n\tmax-width: 1328px;\n\t', ';\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tpadding: ', ';\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tmargin-top: ', ';\n'], ['\n\tmargin-top: ', ';\n']);

var StyledWrapper$1 = styled('div')(_templateObject$1, colours.backgrounds.shell, function (props) {
  return props.theme.images.pageBackground && breakpointAndUp.lg1('\n\t\t\tbackground-image: url(' + props.theme.images.pageBackground + ');\n\t\t\tbackground-position: center -13rem;\n\t\t\tbackground-repeat: repeat-y;\n\t\t');
});
var StyledContentWrapper$1 = styled('div')(_templateObject2$1);
var StyledContainer$1 = styled('div')(_templateObject3$1, spacing(2), spacing(2), breakpointAndUp.lg1('margin-top: ' + spacing(4)));
var StyledMain$1 = styled('main')(_templateObject4$1, colours.neutral.white, function (props) {
  return props.theme.borderRadiusLargest;
}, spacing(2.5));
var StyledFooter$1 = styled('div')(_templateObject5$1, spacing(10));

var DataManagementShell = function DataManagementShell(_ref) {
  var children = _ref.children,
      footer = _ref.footer,
      header = _ref.header,
      utilityNavigation = _ref.utilityNavigation;
  return React.createElement(StyledWrapper$1, null, React.createElement(StyledContentWrapper$1, null, header, utilityNavigation, React.createElement(StyledContainer$1, null, React.createElement(StyledMain$1, null, children))), footer && React.createElement(StyledFooter$1, null, footer));
};

DataManagementShell.propTypes = {
  /** Main column content as node. */
  children: PropTypes.node.isRequired,

  /** Desired footer component as node. */
  footer: PropTypes.node,

  /** Desired header component as node. */
  header: PropTypes.node.isRequired,

  /** Desired utility navigation component as node. */
  utilityNavigation: PropTypes.node
};
DataManagementShell.defaultProps = {};
var WrappedDataManagementShell = withTheme(DataManagementShell);

WrappedDataManagementShell.defaultExample = function (header, nav) {
  return React.createElement(WrappedDataManagementShell, {
    header: header,
    nav: nav
  }, React.createElement('span', null, 'Some test content.'));
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tpadding-bottom: ', ';\n\tpadding-right: ', ';\n'], ['\n\tpadding-bottom: ', ';\n\tpadding-right: ', ';\n']);

var StyledWrapper$2 = styled('div')(_templateObject$2, spacing(2), spacing(2));

var ShellInnerSpacer = function ShellInnerSpacer(_ref) {
  var children = _ref.children;
  return React.createElement(StyledWrapper$2, null, children);
};

ShellInnerSpacer.propTypes = {
  /** Child content as node. */
  children: PropTypes.node.isRequired
};
ShellInnerSpacer.defaultProps = {};

ShellInnerSpacer.defaultExample = function () {
  return React.createElement(ShellInnerSpacer, null, React.createElement('div', null, React.createElement('p', null, 'Sample test content.')));
};

export { WrappedApplicationFormShell as ApplicationFormShell, WrappedDataManagementShell as DataManagementShell, ShellInnerSpacer };